export default {"src":"/_next/static/media/uz.c4379544.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};